module.exports = __webpack_public_path__ + "static/media/Group_play_app.499037d5.png";